import React from 'react'
import SkillBox from './SkillBox';
import { Stack } from '@mui/material';

const Skills = () => {
    const languages = [
        { language: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg", name: "Python" },
        { language: "https://upload.wikimedia.org/wikipedia/en/3/30/Java_programming_language_logo.svg", name: "Java" },
        { language: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png", name: "JavaScript" },
        { language: "https://upload.wikimedia.org/wikipedia/commons/1/19/C_Logo.png", name: "C" },
        { language: "https://upload.wikimedia.org/wikipedia/commons/b/bd/Logo_C_sharp.svg", name: "C#" },
        { language: "https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg", name: "HTML" },
        { language: "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg", name: "CSS" }
    ];
    const frameworks = [
        { name: "React.js", src: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" },
        { name: "Flask", src: "https://static-00.iconduck.com/assets.00/programming-language-flask-icon-2048x1826-wf5k5ugs.png" }
    ];
    const tools = [
        { name: "TailwindCSS", src: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg" },
        { name: "MaterialUI", src: "https://mui.com/static/logo.png" }
    ];

    return (
        <main id="skills" className="flex flex-col flex-nowrap bg-slate-100 text-white py-8 sm:py-10 max-w-screen px-3 sm:px-5">
            <h3 className="flex justify-center items-center text-2xl sm:text-3xl my-3 font-semibold text-slate-800">Technical Skills</h3>

            <section className="w-full max-w-5xl mx-auto">
                <Stack className="flex items-center gap-4 sm:gap-6">
                    <Stack item className="w-full">
                        <h4 className="flex justify-center items-center text-lg sm:text-xl my-2 font-medium text-slate-700">Languages</h4>
                        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 px-2">
                            {languages.map((l, idx) => (
                                <div key={idx} className="transform transition-all duration-300 hover:scale-105">
                                    <SkillBox src={l.language} name={l.name} size={80} />
                                </div>
                            ))}
                        </div>
                    </Stack>
                    <Stack item className="w-full">
                        <h4 className="flex justify-center items-center text-lg sm:text-xl my-2 font-medium text-slate-700">Frameworks & Tools</h4>
                        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 px-2">
                            {[...frameworks, ...tools].map((l, idx) => (
                                <div key={idx} className="transform transition-all duration-300 hover:scale-105">
                                    <SkillBox src={l.src} name={l.name} size={80} />
                                </div>
                            ))}
                        </div>
                    </Stack>
                </Stack>
            </section>
        </main>
    )
}

export default Skills